<template>
  <div class="protocol loan-instruction-protocol">
    <navigation>借款须知及风险提示</navigation>
    <section class="content">
      <p class="text tab-2"><b>尊敬的用户：</b></p>
      <p class="text tab-2"><b>为保障您的合法权益，请您确保您在交易时已完全理解并同意本文件内容，请您务必仔细阅读本文件的全部内容（特别是字体加粗内容），关注您的权利与义务。</b></p>
      <p class="text tab-2">重庆市崇天小额贷款有限公司及/或其关联方（包括但不限于上海瓴峰科技有限公司等，以下简称“我们”）将为您提供金融科技服务并以推荐人身份为您向资金方及或合作第三方申请贷款服务及其他金融服务（以下简称“贷款服务”）。<b>如您不符合下列申请条件或不同意本文件的任何内容，请您立即停止操作。如果继续操作，则表示您接受本文件全部内容并愿意承担相应的法律后果。</b></p>
      <p class="text tab-2"><b>一、贷款服务申请条件</b></p>
      <p class="text tab-2">您在申请贷款服务前须确认并保证您同时满足以下条件，并承诺在贷款服务使用期间内始终有效：</p>
      <p class="text tab-2"><b>1.您具有签订和履行贷款服务相关合同的资格和能力，可独立地作为一方诉讼主体。即您系已年满18周岁且具有完全民事行为能力的中国公民（非在读学生身份）；</b></p>
      <p class="text tab-2"><b>2.您的个人资信状况良好，无大额透支和逾期等不良信息记录；</b></p>
      <p class="text tab-2"><b>3.您有足够的偿债能力履行贷款服务相关合同项下义务，您拥有稳定收入来源，对资产具有完全的处置权利；</b></p>
      <p class="text tab-2"><b>4.您提供给我们的所有信息、文件和资料都是真实、准确、完整、合法和有效的，不存在虚假记载、重大遗漏或误导性陈述；</b></p>
      <p class="text tab-2"><b>5、本文件项下的所有授权（如有）在您使用贷款服务期间持续有效。</b></p>
      <p class="text tab-2"><b>二、用户授权</b></p>
      <p class="text tab-2">为保证我们的服务质量，您同意并不可撤销的向我们授权如下：</p>
      <p class="text tab-2">1.您同意并授权我们按照国家相关规定<b>采集您的个人信息（包括但不限于个人身份信息、财产信息、交易信息、行为信息、信用信息、负债信息、履约能力判断信息）</b>，<b>并按照要求将您的个人信息和分析结果传输给银行、消费金融公司、小额贷款公司、信托公司等资金方、合作第三方（包括但不限于向您提供担保服务的融资担保公司等）以及依法设立的征信机构。</b>您授权我们协助资金方、合作第三方和征信机构对您的个人信息进行采集、加工、储存、整理、分析以审核您的贷款服务申请、处理售后/贷后管理事务、回款/贷后催收和处理征信异议。</p>
      <p class="text tab-2">2.您同意并授权<b>我们在您自行提供的信息与我们通过第三方采集的信息存在冲突（包括但不限于信息遗漏、信息错误等）时依据我们通过第三方采集的信息对您提供的信息进行整理、校正。如您发现我们的整理、校正有误，请您及时与我们联系以便调整。</b></p>
      <p class="text tab-2">3.您同意并授权我们根据您提交或确认订单时所提交的贷款服务请求，<b>将您的贷款服务相关订单信息传输给资金方和合作第三方，并将借款信息、担保信息、还款要求、账单信息及后续逾期相关催收信息通过电话、手机短信、电子邮件、App或网站通知等方式通知您。</b></p>
      <p class="text tab-2">4.<b>您同意并授权我们/资金方/合作第三方向合作的电子签名认证机构申请您的数字证书以用于您签署贷款服务相关的在线电子合同</b>，该数字证书由合作的电子签名认证机构保存。</p>
      <p class="text tab-2">5.<b>您同意并授权我们根据您的操作指令协助您将您的还款款项或其他应付款项通过第三方支付机构和/或清结算银行划扣后支付给资金方或合作第三方。</b></p>
      <p class="text tab-2"><b>6.您知悉并确认，为您提供贷款服务的资金方/合作第三方有权将其享有的对您的债权依据法律规定与合同约定进行转让，且您明确授权我们为上述债权转让提供协助服务（包括但不限于协助进行债权转让通知等）。</b></p>
      <p class="text tab-2"><b>7.您授权我们可将上述授权事项的部分或者全部进行转委托。</b></p>
      <p class="text tab-2"><b>三、用户承诺</b></p>
      <p class="text tab-2">1.您承诺，<b>因任何原因导致您的同一笔订单出现重复放款或放款金额大于您的申请金额或出现两个及两个以上资金方为您的同一笔借款申请放款，您不可撤销地授权我们或资金方直接从您的还款账户中对重复发放的多余款项进行划回扣收。</b>如划回扣收失败，您亦将根据我们的规则或要求，向我们或资金方退回多于您申请金额的放款资金。如您拒绝归还，则资金方有权以实际放款金额作为借款本金并向您收取相应利息。</p>
      <p class="text tab-2">2.您承诺，将按照我们通过贷款服务平台（天美贷）所展示的账单金额、分期期数、还款日等信息向资金方、合作第三方以及相关债权受让方按时偿还/支付付当期应付款项。</p>
      <p class="text tab-2"><b>四、用途限制</b></p>
      <p class="text tab-2">您向资金方申请的贷款仅限于约定的个人消费用途。严禁将贷款用于支付购房首付贷、基金、股票、理财产品、有价证券、期货买卖、股本权益性投资和各种非消费场景。若您违规使用贷款，资金方及合作第三方有权要求您按相关合同约定承担违约责任，具体规则请查阅相关合同文本。</p>
      <p class="text tab-2"><b>五、逾期违约责任</b></p>
      <p class="text tab-2">如您未能按期足额偿还/支付应付款项，您可能需要向资金方支付逾期利息、罚息，以及向合作第三方支付违约金，具体规则请查阅相关合同文本，请您务必按时还款。</p>
      <p class="text tab-2"><b>六、重要提示</b></p>
      <p class="text tab-2"><b>1.您明确知悉：借款综合利率与个人资信状况、还款能力等情况有关，不同人以及同一人不同时间段的资信状况及风险情况会有不同，借款综合利率也会有所不同。您的具体订单对应借款综合利率以您下单时展示的借款合同及订单展示为准。</b></p>
      <p class="text tab-2"><b>2、请您珍视信用、量力而行；理性消费 ，切勿多头借贷、以贷养贷及借取地下高利贷。遇到欺诈、暴力催收行为，请寻求公安机关、司法机关的协助。</b></p>
      <p class="text tab-2">用户姓名（签名）：</p>
      <p class="text tab-2">用户身份证号： </p>
      <p class="text tab-2">签署日期： </p>
    </section>
    <p data-sensors-exposure-property-page_status="page_bottom" data-sensors-exposure-event-name="general_event">&nbsp;<!-- 监听协议滑动到了底部，每个协议都加上--></p>
  </div>
</template>

<script>
import underline from '../tmd/underline'
export default {
  name: 'loan-instruction-protocol',

  components: {
    underline
  },

  data () {
    return {
    }
  },
  created () {
    this.$bus.$emit('ready')
  },
  mounted () {
  },
  methods: {

  }
}
</script>

<style scoped lang="less">
@import "../../assets/less/mixin.less";

.loan-instruction-protocol {
  width: 100%;
  position: relative;

  .bolder {
    font-weight: bolder;
  }

  .text {
    text-indent: 40px;
  }

  .text:last-child {
    margin-bottom: 100px;
  }

  .tab-0 {
    text-indent: 0;
  }

  .underline {
    text-indent: 200px;
    font-weight: bold;
    text-decoration: underline;
  }

  .underline:last-child {
    margin-bottom: 100px;
  }
}
</style>
